import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { InterviewReportDto } from './interview-report-dto'



export class InterviewReportResponse extends GlobalResponseObject{
    data?: InterviewReportDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: InterviewReportDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}